import React from 'react';

import Custom404 from './404';

function Fallback(): JSX.Element {
  return <Custom404 />;
}

export default Fallback;
